import React from 'react';
import './socialLinks.css';

function SocialLinks() {
    return (
        <div className="socialLinks">
            {/* <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon facebook">
                <i className="bi bi-facebook"></i>
            </a> */}
            {/* <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
                <i className="bi bi-instagram"></i>
            </a> */}
            <a href="https://wa.me/963957362344" target="_blank" rel="noopener noreferrer" className="social-icon whatsapp">
                <i className="bi bi-whatsapp"></i>
            </a>
            <a href="mailto:Seen7.company@gmail.com" target="_blank" rel="noopener noreferrer" className="social-icon mail">
                <i className="bi bi-envelope-fill"></i>
            </a>
        </div>
    );
}

export default SocialLinks;
